import { Draft } from '@/types';

export const getAppearance = (draft: Draft) => draft.appearance;
